import PortalVue from 'portal-vue';

export default function(VueInstance) {
  VueInstance.use(PortalVue);
}
